import { Component, OnDestroy } from '@angular/core';
import { TableComponent } from "../../../shared/component/table/table.component";
import { ConfigPaginationService } from '../configuration/configpagination.service';
import { DestroyableComponent } from '../../../shared/services/destroyable.component';
import { takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { ReportPaginationService } from '../Reports/report-pagination.service';
import { LogsPaginationService } from '../log/log-table/logs-pagination.service';

@Component({
  selector: 'app-cutoffmeter-list',
  imports: [TableComponent],
  templateUrl: './cutoffmeter-list.component.html',
  styleUrl: './cutoffmeter-list.component.scss'
})
export class CutoffmeterListComponent extends DestroyableComponent implements OnDestroy {
  totalcount: number = 0
  siteId: string = ''
  table_header: string = 'Total Postpaid Meters List'
  constructor(
    private router: Router,
    private pagination: LogsPaginationService
  ) {
    super()
  }
  ngOnInit() {
    this.pagination.totalCount$.subscribe(res => {
      this.totalcount = res
    })
    const login_type = localStorage.getItem('login_Type')
    if (login_type === 'FA') {
      this.table_header = 'Total Postpaid Meters List'
    } else {
      this.table_header = 'Total Postpaid Meters List'
    }
    this.updateConfigFromRoute();
  }
  private updateConfigFromRoute() {

    // 1️⃣ Extract URL segments (without query params)
    const urlTree = this.router.parseUrl(this.router.url);
    // 2️⃣ Extract query param: siteid
    const encodedId = urlTree.queryParams['siteid'] || localStorage.getItem('site_idLogin');

    // 3️⃣ Decode siteid safely
    let decodedSiteId = '';
    if (encodedId) {
      try {
        decodedSiteId = atob(encodedId);
      } catch (e) {
        decodedSiteId = '';
      }
    }

    this.siteId = decodedSiteId;
    const payload = {
      site_id: this.siteId
    }
    this.handleFilters(payload)
  }
  handleFilters(payload: any) {
    this.pagination.initFilters(
      payload,
      'CutMeterNoList',
      this.destroy$,
      '',
      'Cut Meter List'

    );
  }

  handlePageChange(event: { page: number; pageSize: number }) {
    this.pagination.changePage(event, this.destroy$);
  }


  override ngOnDestroy(): void {
    this.handlereset(false);
  }
  handlereset(show: boolean) {
    if (!show) {
      this.pagination.reset();
    }
  }
}
